module.exports = __webpack_public_path__ + "media/img/trainee-program/card_magazine-48228df6a6fd7c320078f9749feb4730.png";